import React from "react";
import styles from "./Hyperlink.module.css";
import { joinClassNames } from "../../utils/joinClassNames";

export type HyperlinkProps = {
    children: React.ReactNode;
    className?: string;
    href: string;
    isExternalLink?: string;
    iconPath?: React.ReactElement<SVGElement>;
    target?: string;
    rel?: string;
};

export const Hyperlink = ({
    children,
    className,
    href,
    isExternalLink,
    iconPath,
    target,
    rel,
}: HyperlinkProps) => {
    const cssClasses = joinClassNames([styles.link, className ?? ""]);
    const showLink =
        href.trim() &&
        ((typeof children === "string" && children.trim()) || children);
    const linkRel = rel ?? (target === "_blank" ? "noopener noreferrer" : undefined);
    return showLink ? (
        <a
            href={href.trim()}
            className={cssClasses}
            target={target}
            rel={linkRel}
        >
            {children}
            {isExternalLink && iconPath}
        </a>
    ) : null;
};

export default Hyperlink;
